<template>
  <BaseModal modal-content-class="unsub">
    <div class="content">
      <h1>{{ $_translations.value.modal_unsubscribe_via_web_title }}</h1>

      <BaseImage
        src="/static/images/modals/unsubscribe/unsubscribe_icon.svg"
        alt="unsubscribe icon"
        image-class="top_img"
      />

      <p>
        <span class="white_bold">
          <span class="yellow_bold">
            {{ authStore.userUsername }}
          </span>,
          {{ $_translations.value.modal_unsubscribe_via_web_subtitle }}
        </span>
      </p>

      <p>{{ $_translations.value.modal_unsubscribe_via_web_description }}</p>


      <BaseButton
        container-default-class=""
        button-class="outline_btn"
        :disabled="submitting"
        @click:button="handleProceed"
      >
        {{ $_translations.value.modal_unsubscribe_via_web_button_proceed }}
      </BaseButton>

      <BaseButton
        container-class="cancel"
        button-class="fancy_btn close_modal"
        :disabled="submitting"
      >
        {{ $_translations.value.modal_unsubscribe_via_web_button_cancel }}
      </BaseButton>
    </div>
  </BaseModal>
</template>

<script setup>
import { ref } from 'vue';
import BaseModal from '@/components/modal/BaseModal.vue';
import BaseImage from '@/components/image/BaseImage.vue';
import BaseButton from '@/components/button/BaseButton.vue';
import useAuthStore from '@/store/modules/auth.js';
import { apiOptoutApiCall } from '@/services/general.js';

const emits = defineEmits(['unsubscribe:viaWeb']);

const authStore = useAuthStore();

const submitting = ref(false);

const handleProceed = async () => {
  try {
    submitting.value = true;

    await apiOptoutApiCall();
    await authStore.dispatchRetrieveAuthUser();

    emits('unsubscribe:viaWeb', { status: 'success' });
  } catch {
    emits('unsubscribe:viaWeb', { status: 'error' });
  } finally {
    submitting.value = false;
  }
};
</script>
